import { queryOptions } from '@tanstack/vue-query'
import { getChats } from '../api/get-chats'

export const PUBLIC_CHATS_QUERY_KEY = ['chats', 'public'] as const

export const publicChatsQueryOptions = queryOptions({
  queryKey: PUBLIC_CHATS_QUERY_KEY,
  queryFn: () => getChats('public', { count: 50 }),
  refetchOnWindowFocus: false,
  staleTime: 300_000,
})
